module.exports = __webpack_public_path__ + "img/9788950967314.520cece2.jpg";